<br>
<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
>
</app-st-banner>
<br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-md-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-md-8">
      <app-st-header-title [inputVal]="'Dashboard'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSubscriptionMessages" class="container st-form alert-danger" #goUp>
    <div *ngFor="let subscriptionMessage of subscriptionMessages" class="alert alert-danger" role="alert">
      <b>{{subscriptionMessage.field}}:</b> {{subscriptionMessage.detail}}
      <app-st-button [idVal]="'activate-subscription-button-id'" [label]="'Activate Subscription'"
                     [primary]="true" (click)="this.navToSubscriptionRenewalPage()"></app-st-button>
    </div>
    <br>
  </div>

  <div class="container st-form webtext-black">
    <app-st-button-filter *ngIf="this.sideMenuOpened" [idVal]="'hide-menu-button-id'" [label]="'Hide Menu'"
                          (click)="this.toggleSideMenu()"></app-st-button-filter>
    <app-st-button-filter *ngIf="!this.sideMenuOpened" [idVal]="'open-menu-button-id'" [label]="'Open Menu'"
                          (click)="this.toggleSideMenu()"></app-st-button-filter>
    <br>
    <div [id]="'menu-dashboard-id'" class="row">
      <div *ngIf="this.sideMenuOpened" class="col-sm-3">
        <div *ngIf="this.isConsultant == 'Y'">
          <br>
          <div class="row" (click)="toggleAccountsVisible()">
            <div class="col-md-12" >
              <div class="card">
                <div class="card-body st-menu-select">
                  <h5 class="card-title webtext-white"><b>Select Account  </b>
                    <i *ngIf="!this.accountsVisible" class="bi bi-chevron-up"></i><i *ngIf="this.accountsVisible" class="bi bi-chevron-down"></i>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.accountsVisible">
            <div class="row" *ngFor="let user of users; let i = index">
              <div class="col-md-12" >
                <div class="card">
                  <div class="card-body st-menu-select" (click)="this.navToDashboard(user)">
                    <h5 *ngIf="this.username == user.username" class="card-title webtext-white"><b>Your Consultant Account</b></h5>
                    <h5 *ngIf="this.username != user.username" class="card-title webtext-white"><b>Client Account</b></h5>
                    <p class="card-text webtext-white" >
                      {{user.companyName}}<br>
                      {{user.firstName}} {{user.lastName}}<br>
                      {{user.email}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="solid">
        </div>
        <br>
        <div *ngIf="(this.username && this.impersonatedEmail == null)" class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToUserProfilePage()"
                   title="View your account details.">
                <h5 class="card-title webtext-white">Your Profile</h5>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="(this.username && this.impersonatedEmail == null)" class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToChangePasswordPage()"
                   title="Manage your password here.">
                <h5 class="card-title webtext-white">Change Password</h5>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToGeneralFeedbackPage()"
                   title="Suggest new features / feedback.">
                <h5 class="card-title webtext-white">Your Wishlist</h5>
              </div>
            </div>
          </div>
        </div>
        <hr class="solid">

        <div *ngIf="this.subscriptionActive">
          <div class="row">
            <div class="col-md-12" >
              <div class="card">
                <div class="card-body st-menu-select" (click)="this.navToSearchDonorsPage()"
                     title="Search Donors with filters.">
                  <h5 class="card-title webtext-white">Search Donors</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" >
              <div class="card">
                <div class="card-body st-menu-select" (click)="this.navToSearchGrantsPage()"
                     title="Search Grants with filters.">
                  <h5 class="card-title webtext-white">Search Grants</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" >
              <div class="card">
                <div class="card-body st-menu-select" (click)="this.navToSearchNonprofitsPage()"
                     title="Search Nonprofits with filters.">
                  <h5 class="card-title webtext-white">Search Nonprofits</h5>
                </div>
              </div>
            </div>
          </div>
          <hr class="solid">
        </div>


        <div class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToFundingGoalsPage()"
                   title="Manage your funding goals here.">
                <h5 class="card-title webtext-white">Your Funding Goals</h5>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToSavedSearchesPage()"
                   title="Manage your saved searches here.">
                <h5 class="card-title webtext-white">Your Saved Searches</h5>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="(this.username && this.impersonatedEmail == null)" class="row">
          <div class="col-md-12" >
            <div class="card">
              <div class="card-body st-menu-select" (click)="this.navToSubscriptionsPage()"
                   title="Manage your subscription, partners, and consultants.">
                <h5 class="card-title webtext-white">Subscription</h5>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="this.sideMenuOpened" [id]="'open-main-columns-id'" class="col-sm-9">
        <br>
        <div class="row" >
          <div class="col-md-2" >
            <h4 class="card-title webtext-black"><u>Blogs</u></h4>
          </div>
          <div class="col-md-8" >
          </div>
          <div class="col-md-2" >
            <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
              <app-st-button [idVal]="'blogs-see-all-id'" [label]="'See All'" [primary]="true"
                             (click)="this.navToWebpage('https://www.scalanthropy.com/blog')"></app-st-button>
            </div>
          </div>
        </div>
        <br>
        <div [id]="'blog-first-row-id'" class="row">
          <div *ngFor="let firstRowBlog of this.firstRowBlogs" class="col-md-4">
            <div class="card  blogRow">
              <div class="card-body">
                <a [href]="firstRowBlog['valueTxt']" target="_blank">
                  <img [src]="firstRowBlog['imageLink']"  alt="Logo" width="200" height="150" class="display-2 d-inline-block align-text-top">
                </a>
                <div class="blogTitleRow">
                  <p class="card-title webtext-black blogTitleRow">{{firstRowBlog['displayName']}}</p>
                </div>
                <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                  <app-st-button [idVal]="'blog-first-row-button-id'" [label]="'Read'" [primary]="true"
                                             (click)="this.navToWebpage(firstRowBlog['valueTxt'])"></app-st-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [id]="'blog-second-row-id'" class="row">
          <div *ngFor="let secRowBlog of this.secondRowBlogs" class="col-md-4">
            <div class="card  blogRow">
              <div class="card-body">
                <a [href]="secRowBlog['valueTxt']" target="_blank">
                  <img [src]="secRowBlog['imageLink']"  alt="Logo" width="200" height="150" class="display-2 d-inline-block align-text-top">
                </a>
                <div class="blogTitleRow">
                  <p class="card-title webtext-black blogTitleRow">{{secRowBlog['displayName']}}</p>
                </div>
                <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                  <app-st-button [idVal]="'blog-sec-row-button-id'" [label]="'Read'" [primary]="true"
                                             (click)="this.navToWebpage(secRowBlog['valueTxt'])"></app-st-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="row" >
          <div class="col-md-2" >
            <h4 class="card-title webtext-black"><u>Guides</u></h4>
          </div>
          <div class="col-md-8" >
          </div>
          <div class="col-md-2" >
            <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
              <app-st-button [idVal]="'guides-see-all-id'" [label]="'See All'" [primary]="true"
                               (click)="this.navToWebpage('https://www.scalanthropy.com/guides')"></app-st-button>
            </div>
          </div>
        </div>
        <br>
        <div [id]="'guide-first-row-id'" class="row">
          <div *ngFor="let firstRowGuide of this.firstRowGuides" class="col-md-4">
            <div class="card blogRow">
              <div class="card-body">
                <a [href]="firstRowGuide['valueTxt']" target="_blank">
                  <img [src]="firstRowGuide['imageLink']"  alt="Logo" width="200" height="150" class="display-2 d-inline-block align-text-top">
                </a>
                <div class="blogTitleRow">
                  <p class="card-title webtext-black blogTitleRow">{{firstRowGuide['displayName']}}</p>
                </div>
                <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                  <app-st-button [idVal]="'guide-first-row-button-id'" [label]="'Learn'" [primary]="true"
                                             (click)="this.navToWebpage(firstRowGuide['valueTxt'])"></app-st-button>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div [id]="'guide-sec-row-id'" class="row">
          <div *ngFor="let secRowGuide of this.secRowGuides" class="col-md-4">
            <div class="card blogRow">
              <div class="card-body">
                <a [href]="secRowGuide['valueTxt']" target="_blank">
                  <img [src]="secRowGuide['imageLink']"  alt="Logo" width="200" height="150" class="display-2 d-inline-block align-text-top">
                </a>
                <div class="blogTitleRowMenuClosed">
                  <p class="card-title webtext-black">{{secRowGuide['displayName']}}</p>
                </div>
                <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                  <app-st-button [idVal]="'guide-sec-row-button-id'" [label]="'Learn'" [primary]="true"
                                 (click)="this.navToWebpage(secRowGuide['valueTxt'])"></app-st-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!this.sideMenuOpened" [id]="'closed-main-columns-id'" class="col-sm-12">
      <br>
      <div class="row" >
        <div class="col-md-2" >
          <h4 class="card-title webtext-black"><u>Blogs</u></h4>
        </div>
        <div class="col-md-8" >
        </div>
        <div class="col-md-2" >
          <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
            <app-st-button [idVal]="'blogs-see-all-id'" [label]="'See All'" [primary]="true"
                           (click)="this.navToWebpage('https://www.scalanthropy.com/blog')"></app-st-button>
          </div>
        </div>
      </div>
      <br>
      <div [id]="'blog-first-row-id'" class="row">
        <div *ngFor="let firstRowBlog of this.firstRowBlogs" class="col-md-4">
          <div class="card blogRow">
            <div class="card-body">
              <a [href]="firstRowBlog['valueTxt']" target="_blank">
                <img [src]="firstRowBlog['imageLink']"  alt="Logo" width="250" height="188" class="display-2 d-inline-block align-text-top">
              </a>
              <div class="blogTitleRowMenuClosed">
                <p class="card-title webtext-black">{{firstRowBlog['displayName']}}</p>
              </div>
              <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                <app-st-button [idVal]="'blog-first-row-button-id'" [label]="'Read'" [primary]="true"
                                           (click)="this.navToWebpage(firstRowBlog['valueTxt'])"></app-st-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [id]="'blog-second-row-id'" class="row">
        <div *ngFor="let secRowBlog of this.secondRowBlogs" class="col-md-4">
          <div class="card blogRow">
            <div class="card-body">
              <a [href]="secRowBlog['valueTxt']" target="_blank">
                <img [src]="secRowBlog['imageLink']"  alt="Logo" width="250" height="188" class="display-2 d-inline-block align-text-top">
              </a>
              <div class="blogTitleRowMenuClosed">
                <p class="card-title webtext-black">{{secRowBlog['displayName']}}</p>
              </div>
              <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                <app-st-button [idVal]="'blog-sec-row-button-id'" [label]="'Read'" [primary]="true"
                                           (click)="this.navToWebpage(secRowBlog['valueTxt'])"></app-st-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="row" >
        <div class="col-md-2" >
          <h4 class="card-title webtext-black"><u>Guides</u></h4>
        </div>
        <div class="col-md-8" >
        </div>
        <div class="col-md-2" >
          <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
            <app-st-button [idVal]="'guides-see-all-id'" [label]="'See All'" [primary]="true"
                           (click)="this.navToWebpage('https://www.scalanthropy.com/guides')"></app-st-button>
          </div>
        </div>
      </div>
      <br>
      <div [id]="'guide-first-row-id'" class="row">
        <div *ngFor="let firstRowGuide of this.firstRowGuides" class="col-md-4">
          <div class="card blogRow">
            <div class="card-body">
              <a [href]="firstRowGuide['valueTxt']" target="_blank">
                <img [src]="firstRowGuide['imageLink']"  alt="Logo" width="250" height="188" class="display-2 d-inline-block align-text-top">
              </a>
              <div class="blogTitleRowMenuClosed">
                <p class="card-title webtext-black">{{firstRowGuide['displayName']}}</p>
              </div>
              <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                <app-st-button [idVal]="'guide-first-row-button-id'" [label]="'Learn'" [primary]="true"
                                           (click)="this.navToWebpage(firstRowGuide['valueTxt'])"></app-st-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [id]="'guide-sec-row-id'" class="row">
        <div *ngFor="let secRowGuide of this.secRowGuides" class="col-md-4">
          <div class="card blogRow">
            <div class="card-body">
              <a [href]="secRowGuide['valueTxt']" target="_blank">
                <img [src]="secRowGuide['imageLink']"  alt="Logo" width="250" height="188" class="display-2 d-inline-block align-text-top">
              </a>
              <div class="blogTitleRowMenuClosed">
                <p class="card-title webtext-black">{{secRowGuide['displayName']}}</p>
              </div>
              <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
                <app-st-button [idVal]="'guide-sec-row-button-id'" [label]="'Learn'" [primary]="true"
                               (click)="this.navToWebpage(secRowGuide['valueTxt'])"></app-st-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>

